/* eslint-disable camelcase */
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";
import { ChangeEvent, useState } from "react";
import { ContatoExterno, ApiContato } from "../../services/api/contatos";

interface Props {
  open: boolean;
  onClose: () => void;
  idBarragem: number;
  onSuccess?: () => void; // callback opcional
}

export const ContatoExternoRegister: React.FC<Props> = ({
  open,
  onClose,
  idBarragem,
  onSuccess,
}) => {
  const [contato, setContato] = useState<Omit<ContatoExterno, "id" | "insertDate" | "updateDate" | "idUpdate">>({
    elemento_notificacao: "",
    email: "",
    sitio: "",
    tipo: "municipal",
    idBarragem,
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setContato({ ...contato, [name]: value });
  };

  const handleSubmit = async () => {
    const response = await ApiContato.createContatoExterno(idBarragem, contato);
    if ("id" in response) {
      onClose();
      setContato({
        elemento_notificacao: "",
        email: "",
        sitio: "",
        tipo: "municipal",
        idBarragem,
      });
      onSuccess?.();
    } else {
      console.error("Erro ao cadastrar:", response.message);
    }
  };

  return (
    <Dialog open={open} fullWidth onClose={onClose}>
      <DialogTitle bgcolor={"#022935"} color="#fff">
        Cadastro de Contato Externo
      </DialogTitle>

      <DialogContent>
        <Box mt={2}>
          <TextField
            required
            label="Elemento de Notificação"
            name="elemento_notificacao"
            fullWidth
            value={contato.elemento_notificacao}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            label="E-mail"
            name="email"
            fullWidth
            value={contato.email}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            label="Sítio"
            name="sitio"
            fullWidth
            value={contato.sitio}
            onChange={handleChange}
            margin="dense"
          />
          <TextField
            required
            select
            label="Tipo"
            name="tipo"
            fullWidth
            value={contato.tipo}
            onChange={handleChange}
            margin="dense"
          >
            <MenuItem value="municipal">Municipal</MenuItem>
            <MenuItem value="estadual">Estadual</MenuItem>
            <MenuItem value="federal">Federal</MenuItem>
          </TextField>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="error" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          disabled={!contato.elemento_notificacao || !contato.tipo}
        >
          Cadastrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
